import React from 'react'
import { Grid, Typography } from '@mui/material'
import PickUp from 'components/pickAndDrop/PickUp';
import meter from 'assets/images/meter.svg'
import car from 'assets/images/CarProfile.svg'
import rideTrackError from 'assets/images/tripErrorImg.svg'
import profile from "assets/images/ProfileVendor.svg";
import CheckIcon from '@mui/icons-material/Check';

// Helper functions
const calculateGSTAmount = (tripDetails) => {
  if (tripDetails?.priceBreakdown) {
    const gstBreakdown = tripDetails.priceBreakdown.breakdown?.find(item => item.chargeType === 'gst');
    return gstBreakdown?.addedCharge || 0;
  }
  return (tripDetails?.cgstAmount || 0) + (tripDetails?.sgstAmount || 0);
};

function formatPrice(value) {
  if (isNaN(value)) return value;
  return Number(value).toLocaleString('en-IN'); // 'en-IN' → Indian format (e.g., 92,495)
}

const getTripCharges = (tripDetails) => {
  if (!tripDetails?.priceBreakdown) return 0;
  const excludedTypes = ['tollCharges', 'parkingCharge', 'discountAmount', 'gst', 'tip', 'pointsRedeem'];
  const baseAmount = tripDetails.priceBreakdown.baseRate || 0;
  const rideFee = parseFloat(tripDetails?.priceBreakdown?.baseFareDisplay || tripDetails?.rideFee - (tripDetails?.priceBreakdown?.baseRate + tripDetails?.priceBreakdown?.surCharge + tripDetails?.priceBreakdown?.platformCharge) || 0);
  const surcharge = tripDetails.priceBreakdown.surCharge || 0;
  const platformCharge = tripDetails.priceBreakdown.platformCharge || 0;
  
  const additionalCharges = tripDetails.priceBreakdown.breakdown
    ?.filter(item => !excludedTypes.includes(item.chargeType))
    ?.reduce((sum, item) => sum + (item.addedCharge || 0), 0) || 0;

  return rideFee + baseAmount + surcharge + platformCharge + additionalCharges;
};

const getBreakdownAmount = (tripDetails, chargeType) => {
  return tripDetails?.priceBreakdown?.breakdown?.find(item => item.chargeType === chargeType)?.addedCharge || 0;
};

function InvoiceMap(props) {
  const tripDetails = props?.tripDetails;

  const handleImgError = (e) => {
    e.target.src = rideTrackError
  }

  const handleDriverImgError = (e) => {
    e.target.src = profile
  }

  const renderChargeSection = (label, amount, subBreakup = null, isNegative = false) => {
    if (!amount || amount <= 0) return null;

    return (
      <Grid item container
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        className='marginbottom20'>
        <Grid item>
          <Typography className='font14'>{label}</Typography>
          {subBreakup}
        </Grid>
        <Grid item>
          <Typography className={`font14 ${isNegative ? 'colorRed' : ''}`}>
            {isNegative ? `-₹${formatPrice(Math.abs(amount))}` : `₹${formatPrice(amount)}`}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const renderTripChargesBreakup = () => {
    const breakupItems = [
      { label: 'Base Rate', value: tripDetails?.priceBreakdown?.baseRate },
      { 
        label: 'Base Fare',
        value: tripDetails?.priceBreakdown?.baseFareDisplay || tripDetails?.rideFee - (tripDetails?.priceBreakdown?.baseRate + tripDetails?.priceBreakdown?.surCharge + tripDetails?.priceBreakdown?.platformCharge),
        ratePer: tripDetails?.type == "1" || tripDetails?.type == "4" ? {lable: 'Rate per KM', value: tripDetails?.priceBreakdown?.baseRatePerKM} : null
      },
      { label: 'Surcharge', value: tripDetails?.priceBreakdown?.surCharge },
      { label: 'Platform Charge', value: tripDetails?.priceBreakdown?.platformCharge },
      { label: 'Peak Hour Charges', value: getBreakdownAmount(tripDetails, 'peakHour') },
      { label: 'Waiting Charge', value: getBreakdownAmount(tripDetails, 'waitingTimeCharge') },
      { label: 'Cancellation Charge', value: getBreakdownAmount(tripDetails, 'cancellationCharge') },
      { label: 'Extra KM', value: getBreakdownAmount(tripDetails, 'extraKm') },
      { label: 'Extra Hours', value: getBreakdownAmount(tripDetails, 'extraHrs') },
      { label: 'Driver Allowance', value: getBreakdownAmount(tripDetails, 'driverAllowance') },
      { label: 'Night Allowance', value: getBreakdownAmount(tripDetails, 'nightAllowance') },
      { label: 'Aditional Charges', value: getBreakdownAmount(tripDetails, 'additionalCharges') },
      { label: 'Placard Charge', value: getBreakdownAmount(tripDetails, 'placard') },
    ];

    return (
      <>
        {breakupItems
          .filter(item => item.value > 0)
          .map((item, index) => (
            <Typography key={index} className='colorGrey font12'>
              {`${item.label}: ₹${formatPrice(item.value)}`}
            </Typography>
          ))}
      </>
    );
  };

  return (
    <Grid container direction='column' justifyContent='center' alignItems='start'>
      <Grid container item
        direction='column'
        md={12}
      >
        <Grid container item direction='row'
          justifyContent='space-between'
          alignItems='start'>
          {props?.magicToken && <Grid item md={10} sm={8} xs={12}>
            <Typography className="font20 fontMedium">
              Trip {" "+tripDetails?.tripId}  <span className="completeText" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, borderRadius: 10, padding: '4px 10px' }}><span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 22, height: 22, backgroundColor: '#fff', borderRadius: '50%' }}><CheckIcon sx={{ color: '#000', fontSize: 16 }} /></span>{tripDetails?.status || ''}</span>
            </Typography>
          </Grid>}
          <Grid item xs={12} style={{ marginTop: 26 }}><Typography className='font24 fontMedium marginBottom25'>Trip Details</Typography></Grid>
        </Grid>

        <Grid item container direction='row'
          justifyContent='space-between'
          alignItems='start'
        >
          <Grid item md={5} sm={12} className='mapAlign' >
            <img src={tripDetails?.tripRouteImage?.url ? tripDetails?.tripRouteImage?.url : rideTrackError} onError={handleImgError} className="width100 height100" alt='mapImage' />
          </Grid>
          <Grid item
            direction='column' md={6} sm={12}
            justifyContent='space-evenly'
            alignItems='center'
          >
            {tripDetails?.driverId !== null && <Grid item container direction='row'
              justifyContent='flex-start'
              alignItems='center'
              className='dashedBottomLine'
            >
              <Grid item >
                <img src={tripDetails?.DriverProfile?.avtar?.url ? tripDetails?.DriverProfile?.avtar?.url : profile} alt='profile' onError={handleDriverImgError} className='profileImage' />
              </Grid>
              <Grid >
                <Typography>{tripDetails?.driverName && tripDetails?.driverName != null ? tripDetails?.driverName : 'NA'}</Typography>
              </Grid>
            </Grid>}
            <Grid item container direction='row'
              justifyContent='flex-start'
              alignItems='center'
              className='dashedBottomLine'>
              <Grid item >
                <img className='marginRight10 iconImage' src={meter} alt='meter' />
              </Grid>
              <Grid>
                <Typography>{tripDetails?.actualDistance + "km " + (tripDetails?.actualTravelTime * 60).toFixed(0) + "min"}</Typography>
              </Grid>
            </Grid>
            {tripDetails?.driverId !== null && <Grid item container direction='row'
              justifyContent='flex-start'
              alignItems='center'
              className='dashedBottomLine'>
              <Grid item>
                <img className='marginRight10 iconImage' src={car} alt='car' />
              </Grid>
              <Grid >
                <Typography>{(tripDetails?.carType && tripDetails?.carType != null ? tripDetails?.carType : 'NA') + " - " + (tripDetails?.carName && tripDetails?.carName != null ? tripDetails?.carName : 'NA')}</Typography>
              </Grid>
            </Grid>}
            <Grid item
              className='dashedLine'>
              <PickUp tableData={tripDetails} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container item direction='column' className='marginTop25' md={12}>
        <Typography className='font24 fontMedium'>Bill Details</Typography>
        <Grid container item direction='column' justifyContent='space-between' 
          alignItems='center' className='billdetails' md={12}>
          
          {/* Header */}
          <Grid item container direction='row' justifyContent='space-between' 
            alignItems='center' className='dashedBottomLine'>
            <Grid item><Typography className='font18 fontNormal'>Description</Typography></Grid>
            <Grid item><Typography className='font18 fontNormal'>Amount</Typography></Grid>
          </Grid>

          {/* Main Charges Sections */}
          {renderChargeSection('Trip Charges', getTripCharges(tripDetails), renderTripChargesBreakup())}

          {/* Points Redeemed Section */}
          {renderChargeSection('Coins Redeemed', Math.abs(getBreakdownAmount(tripDetails, 'pointsRedeem')), null, true)}
          
          {renderChargeSection('Discount', 
            Math.abs(getBreakdownAmount(tripDetails, 'discountAmount')), null, true)}
          
          {renderChargeSection('GST', calculateGSTAmount(tripDetails),
            tripDetails?.priceBreakdown?.breakdown?.find(item => item.chargeType === 'gst')?.meta?.breakup?.map((tax, idx) => (
              <Typography key={idx} className='colorGrey font12'>
                {`${tax.name.toUpperCase()}: ${tax.unitValue}% (₹${tax.totalCharge})`}
              </Typography>
            ))
          )}

          {renderChargeSection('Tolls & Parking', 
            (getBreakdownAmount(tripDetails, 'tollCharges') + getBreakdownAmount(tripDetails, 'parkingCharge')))}
          
          {renderChargeSection('Tip', getBreakdownAmount(tripDetails, 'tip'))}

          {/* Total Amount */}
          <Grid item container direction='row' justifyContent='space-between'
            alignItems='center' className='marginbottom20 solidTopLine paddingTop20'>
            <Grid item>
              <Typography className='font20 fontMedium'>Total</Typography>
              {!!tripDetails?.additionalInfo?.payment?.roundOffValue &&<Typography className='colorGrey font12'>
              {`Round off: ₹+${formatPrice(tripDetails?.additionalInfo?.payment?.roundOffValue)}`}
            </Typography>}
              <Typography className='colorGrey font16'>Final Amount</Typography>
            </Grid>
            <Grid item>
              <Typography className='font20 fontMedium'>
                {`₹${formatPrice(tripDetails?.priceBreakdown?.totalAmount || tripDetails?.totalAmount || 0)}`}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default InvoiceMap;